import { createContext, useContext } from "react";
export type UserContent = {
  user: string | number | null | any;
  setUser: (c: string) => void;
};
export const UserContext = createContext<UserContent>({
  user: 0, // set a default value
  setUser: () => {},
});
export const useUserContext = () => useContext(UserContext);
